<ng-container>
  <svg
    [ftrIcon]="icon()"
    [iconColor]="iconColor()"
    [iconSize]="iconSize()"
    ftrTooltip
    [showDash]="false"
    [message]="tooltipMessage()"
    [anchorElement]="hostElement"
    [position]="tooltipPosition()"
    [alignment]="tooltipAlignment()"
    [forceDisplayState]="tooltipMessage() ? undefined : 'hide'"
  ></svg>
  <span class="icon-button__content" #buttonContent aria-hidden="true">
    <ng-content />
  </span>
</ng-container>
